import { render, staticRenderFns } from "./UiImage.vue?vue&type=template&id=70fbd142&"
import script from "./UiImage.vue?vue&type=script&lang=js&"
export * from "./UiImage.vue?vue&type=script&lang=js&"
import style0 from "./UiImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports